import React from 'react'
import './UploadOverlay.scss'

type Props = {
  progress?: number
  isUploading: boolean
}

export default function UploadOverlay({ progress = 0, isUploading }: Props) {
  if (!isUploading) return null

  return (
    <div className='upload_overlay'>
      <div className='upload_card'>
        <div
          className='progress_circle'
          style={{
            background: `conic-gradient(#0b5fff ${progress * 3.6}deg, #fc6fbb 0deg)`,
          }}
        >
          <div className='progress_inner'>
            <span>{Math.round(progress)}%</span>
          </div>
        </div>

        <p className='upload_text'>Uploading document...</p>
      </div>
    </div>
  )
}
